// src/i18n/es/adminOptions.ts

/**
 * Spanish translations for Admin Options feature
 */
const adminOptions = {
  name: 'Opciones de administración',
  title: 'Opciones de administración',

  // Section navigation
  nav: {
    label: 'Secciones',
    current: 'Sección:',
  },

  // Tab labels
  tabs: {
    devices: 'Dispositivos',
    hotels: 'Instalaciones',
    groups: 'Grupos',
    users: 'Usuarios',
    backups: 'Copias de seguridad',
    notifications: 'Notificaciones',
    labels: 'Etiquetas',
    system: 'Sistema',
  },

  // Pestaña de copias de seguridad (monta el panel de copias compartido)
  backups: {
    title: 'Copias de seguridad',
    description: 'Copias programadas de los datos de la aplicación, con restauración y exportación.',
  },

  // Metadata popover
  metadata: {
    title: 'Metadata del Dispositivo',
    copyJson: 'Copiar como JSON',
    copied: 'Metadata copiado al portapapeles',
    empty: 'Sin metadata disponible',
  },

  // Help
  help: {
    page: 'Gestiona dispositivos, instalaciones y grupos desde una vista consolidada. Usa los botones de alternancia para cambiar entre las diferentes secciones de administracion.',
  },

  // Event Notifications
  eventNotifications: {
    title: 'Notificaciones de eventos',
    subtitle: 'Configure las notificaciones por correo electrónico para los eventos de sus dispositivos.',
    selectHotel: 'Seleccione una instalación',
    selectHotelHelper: 'Elija la instalación para la que desea configurar las notificaciones.',
    noHotels: 'No hay instalaciones disponibles.',
    enabled: 'Activar notificaciones de eventos',
    recipients: {
      title: 'Destinatarios',
      add: 'Añadir',
      placeholder: 'Introduzca un correo electrónico',
      empty: 'No hay destinatarios configurados.',
      invalidEmail: 'Correo electrónico no válido.',
      duplicateEmail: 'Este correo ya está en la lista.',
    },
    preferences: {
      title: 'Eventos a notificar',
      dispenser: 'Dispensador',
      kiosk: 'Kiosco',
      online: 'Online / Móvil',
      general: 'General',
      notifyKeyDispensed: 'Llave dispensada',
      notifyKeyDispensedHelper: 'Un correo por cada llave dispensada (puede generar muchos correos).',
      notifyCardLow: 'Pocas tarjetas',
      notifyCardLowHelper: 'Aviso cuando el dispensador se está quedando sin tarjetas.',
      notifyCardEmpty: 'Sin tarjetas',
      notifyCardEmptyHelper: 'Aviso urgente cuando el dispensador se ha quedado sin tarjetas.',
      notifyCheckInCompleted: 'Check-in completado',
      notifyCheckInCompletedHelper: 'Aviso de check-in completado en el kiosco.',
      notifyPreCheckInCompleted: 'Pre-check-in completado',
      notifyPreCheckInCompletedHelper: 'Aviso de pre-check-in completado online o desde el móvil.',
      notifyCriticalErrors: 'Errores críticos',
      notifyCriticalErrorsHelper: 'Aviso de errores con severidad crítica.',
    },
    actions: {
      save: 'Guardar configuración',
      sendTest: 'Enviar prueba',
      applyToGroup: 'Aplicar a todas las instalaciones del grupo',
    },
    messages: {
      saveSuccess: 'Configuración de notificaciones guardada correctamente.',
      saveError: 'Error al guardar la configuración de notificaciones.',
      testSuccess: 'Correo de prueba enviado correctamente.',
      testError: 'Error al enviar el correo de prueba.',
      applySuccess: 'Configuración aplicada a todas las instalaciones del grupo.',
      applyError: 'Error al aplicar la configuración al grupo.',
      applyConfirm: 'Se copiará la configuración de notificaciones de esta instalación a todas las demás instalaciones del grupo. ¿Desea continuar?',
      disableSuccess: 'Notificaciones desactivadas correctamente.',
      unsavedChanges: 'Tiene cambios sin guardar. ¿Desea descartarlos?',
      noConfig: 'Esta instalación no tiene notificaciones de eventos configuradas. Active las notificaciones para empezar.',
    },
  },
};

export default adminOptions;
